import { RouteObject } from 'react-router';
import DashboardPage from './pages/DashboardPage';
import OrdersPage from './pages/OrdersPage';
import ConsultationsPage from './pages/ConsultationsPage';
import EstatePlansPage from './pages/EstatePlansPage';
import TrustsPage from './pages/TrustsPage';
import TaxSupportPage from './pages/TaxSupportPage';
import InsurancePage from './pages/InsurancePage';
import TradingPage from './pages/TradingPage';
import LlcSetupPage from './pages/LlcSetupPage';
import LandingPage from './pages/LandingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import NotFoundPage from './pages/NotFoundPage';
import ErrorPage from './pages/ErrorPage';
import ProtectedRoute from './components/ProtectedRoute';

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/orders',
    element: (
      <ProtectedRoute>
        <OrdersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/consultations',
    element: (
      <ProtectedRoute>
        <ConsultationsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/estate-plans',
    element: (
      <ProtectedRoute>
        <EstatePlansPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/trusts',
    element: (
      <ProtectedRoute>
        <TrustsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/tax-support',
    element: (
      <ProtectedRoute>
        <TaxSupportPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/insurance',
    element: (
      <ProtectedRoute>
        <InsurancePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/trading',
    element: (
      <ProtectedRoute>
        <TradingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/trading/setup-llc',
    element: (
      <ProtectedRoute>
        <LlcSetupPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/signup',
    element: <LandingPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/refund-policy',
    element: <RefundPolicyPage />,
  },
  {
    path: '/error',
    element: <ErrorPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
